module.exports = __webpack_public_path__ + "img/gear-transparent.f1f718ef.jpg";